import { useEffect, useState } from 'react';
import Header from './components/Header';
import Breaking from './components/Breaking';
import Hero from './components/Hero';
import Timeline from './components/Timeline';
import Sidebar from './components/Sidebar';
import CategoryBand from './components/CategoryBand';
import TopicSquare from './components/TopicSquare';
import FeatureReads from './components/FeatureReads';
import About from './components/About';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      onClick={(e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <Breaking />
      <main>
        <Hero />

        {/* 今日速览 + 热榜 双栏 */}
        <section id="ts" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-12 md:px-6 md:py-14">
          <div className="flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
                <i className="ri-flashlight-line"></i> 实时滚动
              </p>
              <h2 className="heading-font mt-1.5 text-2xl font-extrabold text-foreground-950 md:text-3xl">
                今日速览：一条时间轴看遍今天
              </h2>
            </div>
            <p className="flex items-center gap-1.5 text-xs text-foreground-500">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
              </span>
              正在实时收录全网讨论热点
            </p>
          </div>

          <div className="mt-7 grid grid-cols-1 items-start gap-6 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <Timeline />
            </div>
            <div>
              <Sidebar />
            </div>
          </div>
        </section>

        <CategoryBand />
        <TopicSquare />
        <FeatureReads />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}